import { render, staticRenderFns } from "./OverviewDisplay.vue?vue&type=template&id=10d4694a"
import script from "./OverviewDisplay.vue?vue&type=script&lang=js"
export * from "./OverviewDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports